// Installation is optional. No persistent private state, queued sends or forced reloads.
export class PwaSession {
    public offline = !navigator.onLine;
    public message = '';
    public updateWaiting = false;
    public installReady = false;
    public standalone = matchMedia('(display-mode: standalone)').matches || !!(navigator as any).standalone;
    private prompt: any;
    private registration?: ServiceWorkerRegistration;
    private disposed = false;
    private changed: () => void = () => {};
    private restored: () => Promise<void> = async () => {};
    private connectivity = () => {
        this.offline = !navigator.onLine;
        this.changed();
        if (!this.offline) void this.restored();
    };
    private installEvent = (event: Event) => {
        event.preventDefault(); this.prompt = event; this.installReady = true; this.changed();
    };
    private installed = () => { this.prompt = null; this.installReady = false; this.message = '설치 요청이 처리되었습니다. 기기의 앱 목록에서 확인해 주세요.'; this.changed(); };
    private watchUpdate = () => {
        const worker = this.registration?.installing;
        if (worker) worker.addEventListener('statechange', () => {
            if (!this.disposed) {
                // The first install can briefly be waiting, then activate without a reload.
                this.updateWaiting = !!this.registration?.active && !!this.registration?.waiting; this.changed();
            }
        });
    };
    async init(changed: () => void, restored: () => Promise<void>) {
        this.changed = changed; this.restored = restored;
        window.addEventListener('online', this.connectivity); window.addEventListener('offline', this.connectivity);
        window.addEventListener('beforeinstallprompt', this.installEvent); window.addEventListener('appinstalled', this.installed);
        if (!isSecureContext || !('serviceWorker' in navigator)) {
            this.message = '이 환경에서는 설치형 기능을 확인할 수 없습니다. 웹으로 계속 이용해 주세요.'; this.changed(); return;
        }
        try {
            const registrations = await navigator.serviceWorker.getRegistrations();
            const scope = new URL('/saju/', location.origin).href;
            const script = new URL('/saju/pwa/sw.js', location.origin).href;
            // Do not silently replace an unknown worker or remove another app's cache.
            if (registrations.some(r => scope.startsWith(r.scope) && [r.active,r.waiting,r.installing].some(w => w && w.scriptURL !== script))) {
                this.message = '기존 설치 설정이 있어 설치형 기능 확인을 보류했습니다. 웹으로 이용해 주세요.'; this.changed(); return;
            }
            this.registration = await navigator.serviceWorker.register(script, {scope: '/saju/', updateViaCache: 'none'});
            if (this.disposed) return;
            this.updateWaiting = !!this.registration.active && !!this.registration.waiting;
            this.registration.addEventListener('updatefound', this.watchUpdate); this.watchUpdate();
            this.changed();
        } catch { if (!this.disposed) { this.message = '설치형 기능에 연결하지 못했습니다. 연결 상태를 확인하고 웹으로 이용해 주세요.'; this.changed(); } }
    }
    async install() {
        if (!this.prompt) return;
        const event = this.prompt; this.prompt = null; this.installReady = false;
        try { await event.prompt(); await event.userChoice; }
        catch { this.message = '브라우저 메뉴에서 설치 가능 여부를 확인해 주세요.'; }
        this.changed();
    }
    destroy() {
        this.disposed = true;
        window.removeEventListener('online', this.connectivity); window.removeEventListener('offline', this.connectivity);
        window.removeEventListener('beforeinstallprompt', this.installEvent); window.removeEventListener('appinstalled', this.installed);
        this.registration?.removeEventListener('updatefound', this.watchUpdate);
    }
}
